import React from 'react'
import { Link } from 'react-router-dom'
import logo from "../images/logo.jpeg"
import { useDispatch, useSelector } from 'react-redux';
import { setSidebar, setSearchWindow, setSearchQuery, startLoading } from '../Redux Store/Slice';

function Navbar({ onCartClick }) {
    let dispatch = useDispatch();
    const { isSearchWindowOpen, searchQuery } = useSelector(state => state.appstate);

    const handleSearchChange = (e) => {
        const query = e.target.value;
        dispatch(setSearchQuery(query));
        if (query.length > 0) {
            dispatch(setSearchWindow(true));
        } else {
            dispatch(setSearchWindow(false));
        }
    };
    
    return (
        <div className='navbar'>
            <div className='part_1'>
                <i className='fas fa-bars' onClick={() => {
                    dispatch(setSidebar(true));
                }}></i>
            </div>
            <div className='part_2'>
                <div className='logo'>
                    <img src={logo} alt='well-shape' />
                </div>
                <div className='search-input'>
                    <i className='fas fa-search'></i>
                    <input 
                        type='text' 
                        placeholder='Search for...'
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                </div>
                <div className='icons'>
                    <Link to={"/profile"}><i className='far fa-user'></i></Link>
                    <Link to={"/wishlist"}><i className='far fa-heart'></i></Link>
                    <span onClick={onCartClick} style={{ cursor: 'pointer' }}>
                        <i className='fas fa-shopping-cart'></i>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Navbar